<template src="./index.html"></template>
<script>
import bsdlcontent from '@/components/common/bsdlcontent/index.vue';
import { deleteBatchAutoLog, updateBatchAutoLog } from '@/api/organization';

export default {
    props: {
        bsdlData:{
            type: Object ,
            default: {}
        },
        logId: {
            type: Number,
            default: null
        },
        smsdialog: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        logId:function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.batchLogId = this.logId // 赋值给变量传递给子组件，否则无法使用watch监听到父组件传递的值
                })
            }
        },
        verifyLogo:function(indexVal, oldVal) {
            if (indexVal) {
                updateBatchAutoLog({id: this.logId}).then(res => {})
                this.$emit('closediag', false);
                this.verifyLogo = false;
            }
        }
    },
    components: {
        bsdlcontent
    },
    data() {
        return {
            batchLogId: 0,
            verifyLogo: false,
        }
    },
    mounted() {
    },
    methods: {
        update(val) {
            this.verifyLogo = val;
        },
        closediag() {
            this.$emit('closediag', false);
            deleteBatchAutoLog({id: this.logId}).then(autoLogRes=>{})
        },
    },
    beforeDestroy() {
    }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
